import Step6 from '@/Classes/FollowUp/FollowUpPatint';
export default {
  data() {
    return {
      patientDrugHistoriesTypeList: [
        { title: 'آترواستاتین', id: 1 },
        { title: 'نیتروگیسیرین', id: 2 },
        { title: 'پروپرانولول', id: 3 },
        { title: 'آتنولول', id: 4 },
        { title: 'ASA', id: 5 },
        { title: 'پلاویکس', id: 6 },
        { title: 'لوزارتان', id: 7 },
        { title: 'کاپتوپریل', id: 8 },
        { title: 'فروزماید', id: 9 },
        { title: 'دیگوکسین', id: 10 },
        { title: 'داروهای کاهنده قند خون', id: 14 },
        { title: 'هیدروکلروتیازید', id: 15 },
      ],
      patientDrugHistoriesTypeList_4: [
        { title: 'آترواستاتین', id: 1 },
        { title: 'نیتروگیسیرین', id: 2 },
        { title: 'پروپرانولول', id: 3 },
        { title: 'آتنولول', id: 4 },
        { title: 'ASA', id: 5 },
        { title: 'پلاویکس', id: 6 },
        { title: 'لوزارتان', id: 7 },
        { title: 'کاپتوپریل', id: 8 },
        { title: 'فروزماید', id: 9 },
        { title: 'دیگوکسین', id: 10 },
        { title: 'هیدروکلروتیازید', id: 15 },
        { title: 'مهارکننده های فسفری استراز (تادالافیل، سیلدنافیل و ...)', id: 16 },
      ],
      patientDrugHistoriesTypeList_5: [
        { title: 'آترواستاتین', id: 1 },
        { title: 'نیتروگیسیرین', id: 2 },
        { title: 'پروپرانولول', id: 3 },
        { title: 'آتنولول', id: 4 },
        { title: 'ASA', id: 5 },
        { title: 'پلاویکس', id: 6 },
        { title: 'لوزارتان', id: 7 },
        { title: 'کاپتوپریل', id: 8 },
        { title: 'فروزماید', id: 9 },
        { title: 'دیگوکسین', id: 10 },
        { title: 'انوکساپارین', id: 11 },
        { title: 'لابتالول', id: 12 },
        { title: 'متیل دوپا', id: 13 },
      ],
      mainPatientDrugHistoriesTypeList: [
        { title: 'آترواستاتین', id: 1 },
        { title: 'نیتروگیسیرین', id: 2 },
        { title: 'پروپرانولول', id: 3 },
        { title: 'آتنولول', id: 4 },
        { title: 'ASA', id: 5 },
        { title: 'پلاویکس', id: 6 },
        { title: 'لوزارتان', id: 7 },
        { title: 'کاپتوپریل', id: 8 },
        { title: 'فروزماید', id: 9 },
        { title: 'دیگوکسین', id: 10 },
        { title: 'انوکساپارین', id: 11 },
        { title: 'لابتالول', id: 12 },
        { title: 'متیل دوپا', id: 13 },
        { title: 'داروهای کاهنده قند خون', id: 14 },
        { title: 'هیدروکلروتیازید', id: 15 },
        { title: 'مهارکننده های فسفری استراز (تادالافیل، سیلدنافیل و ...)', id: 16 },
      ],
      selectedPatientDrugHistoriesTypeList: [],
      patientDrugHistory: new Step6.Step6('', null),
      otherPatientDrugHistory: '',
    };
  },
  methods: {
    addOtherPatientDrugHistory: function () {
      if (!this.otherPatientDrugHistory) {
        this.showErrorAlert('سایر نمی تواند خالی باشد');
        return;
      }
      if (!this.otherPatientDrugHistory.replace(/\s/g, '').length) {
        this.showErrorAlert('سایر نمی تواند خالی باشد');
        return;
      }
      this.addPatientDrugHistoryTrumaType(this.otherPatientDrugHistory);
    },
    addPatientDrugHistoryTrumaType: function (title) {
      this.patientDrugHistory.title = title;
      this.patientDrugHistory.patientId = this.patientId;
      this.addPatientDrugHistoryFunction(this.patientDrugHistory);
    },
    patientDrugHistoryTrumaTypeAdded: function () {
      this.otherPatientDrugHistory = '';
    },
    setData: function (data) {
      this.selectedPatientDrugHistoriesTypeList = [];
      for (let i = 0; i < data.length; i++) {
        let flag = false;
        for (let j = 0; j < this.patientDrugHistoriesTypeList.length; j++) {
          if (data[i].title == this.patientDrugHistoriesTypeList[j].title) {
            flag = true;
            this.selectedPatientDrugHistoriesTypeList.push(data[i]);
            this.patientDrugHistoriesTypeList.splice(j, 1);
          }
        }
        if (!flag) {
          this.selectedPatientDrugHistoriesTypeList.push(data[i]);
        }
      }
    },
    removeItem: function (title) {
      for (let i = 0; i < this.mainPatientDrugHistoriesTypeList.length; i++) {
        if (title == this.mainPatientDrugHistoriesTypeList[i].title) {
          this.patientDrugHistoriesTypeList.push({
            title: title,
            id: this.patientDrugHistoriesTypeList.length + 1,
          });
        }
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab2Step(4, true);
    },
    backToStep6: function () {
      this.$root.$refs.FollowUpPatient.changeTab2Step(2, true);
    },
  },
};
